import {useUp} from 'quickstart/system'
import {Box} from '../Box'

export const Sidebar = props =>
  useUp('lg') ? <Box col={0.25} mr="2rem" {...props} /> : null
